// 9fbef606107a605d69c0edbcd8029e5d
const labelsObj = {
  global: {
    placeRewards: {
      referred: [
        {
          name: 'Bonus Points Days Details',
          contentId: '804fb668-dcd8-4f2d-97b9-0c071d8e787a',
          __typename: 'ReferredContent',
        },
        {
          name: 'Point History Content',
          contentId: 'a0907d9f-c58b-4121-8376-ab6becc73d37',
          __typename: 'ReferredContent',
        },
      ],
      lbl_my_rewards_heading: 'REWARDS & COUPONS',
      ACC_LBL_MY_REWARDS_NO_REWARDS_MSG:
        'There are no coupons in your wallet. Start shopping to earn points and rewards! ',
      lbl_my_rewards_no_available_rewards: 'There are no available rewards. ',
      lbl_my_rewards_start_shopping: 'Start shopping to earn points!',
      lbl_my_rewards_point_balance: 'Points Balance',
      lbl_place_rewards_day: 'DAY',
      lbl_bonus_points_available_today: 'AVAILABLE TODAY!',
      lbl_bonus_points_used_on: 'USED ON',
      lbl_bonus_points_future_use: 'AVAILABLE FOR FUTURE USE',
      lbl_my_rewards_points_history: 'Points History',
      lbl_my_rewards_used_all: "You've used all your available Bonus Points Days.",
      lbl_bonus_points_daysLeft: 'You have {0} day left. ',
      lbl_bonus_points_bonusPointsDay: 'BONUS POINTS DAY',
      lbl_my_rewards_wallet_heading: 'AVAILABLE REWARDS & OFFERS',
      lbl_my_wallet_heading: 'MY WALLET',
      lbl_common_applied_to_order: 'APPLIED TO ORDER',
      lbl_my_rewards_helpLink: 'How to redeem PLACE Bucks.',
      lbl_my_rewards_drawerHeading: 'AVAILABLE REWARDS & OFFERS',
      lbl_my_rewards_viewAll: 'View All ',
      lbl_my_rewards_emptySupportingText: 'There are no available offers in your Wallet.',
      lbl_my_rewards_applied: 'APPLIED!',
      lbl_showMemberId: 'Show Member ID',
      lbl_my_coupon_title: 'Offers',
    },
  },
  account: {
    common: {
      lbl_rewardprogram_link: '/content/myplace-rewards-page',
      lbl_termcondition_link: '/help-center/myplacerewards#termsandconditions',
      lbl_common_point_balance: 'Points Balance',
      lbl_common_earnExtraPoints: 'Earn Extra Points',
      lbl_common_points_history_heading: 'POINTS HISTORY',
      lbl_common_points_history: 'Points History',
    },
  },
};

export default labelsObj;
